<div class="app-page" style="margin-left: 30px;">
  <div style="font-family: Roboto; font-size: 32px;">
    MY TASKS
  </div>
  @for (task of this.Tasks; track task) {
    <app-my-task-row [Task]="task" ></app-my-task-row>
  }

</div>

